import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.screen
import qs from 'qs'

// 查询待办事项列表
export function getAffairs(data) {
  return request({
    url: serviceName + '/affair/list?' + qs.stringify(data),
    method: 'get',
  })
}

// 新增待办事项
export function createAffair(data) {
  return request({
    url: serviceName + '/affair/add',
    method: 'post',
    data
  })
}

// 更新待办事项
export function updateAffair(data) {
  return request({
    url: serviceName + '/affair/update',
    method: 'post',
    data: data
  })
}

// 删除待办事项
export function deleteAffair(id) {
  return request({
    url: serviceName + '/affair/delete?id=' + id,
    method: 'post',
    data: { id }
  })
}

// 查询评论列表
export function getComments(affairId, data) {
  return request({
    url: serviceName + '/comments/list?affairId=' + affairId + '&' + qs.stringify(data),
    method: 'get',
  })
}

// 发表评论
export function createComment(affairId, data) {
  return request({
    url: serviceName + '/comments/add?affairId=' + affairId + '&' + qs.stringify(data),
    method: 'post',
    data: { affairId, ...data }
  })
}

// 删除评论
export function deleteComment(id) {
  return request({
    url: serviceName + '/comments/delete?id=' + id,
    method: 'post',
    data: { id }
  })
}

// 评论点赞/取消点赞
export function toggleLike(commentId) {
  return request({
    url: serviceName + '/comments/like?commentId=' + commentId,
    method: 'post',
    data: { commentId }
  })
}

// 评论点踩/取消点踩
export function toggleDislike(commentId) {
  return request({
    url: serviceName + '/comments/dislike?commentId=' + commentId,
    method: 'post',
    data: { commentId }
  })
}

// 新增图片(待办事项配图)
export function uploadAffairImage(file, imgRatio, type) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('imgRatio', imgRatio)
  formData.append('type', type)
  return request({
    url: serviceName + '/affair/image/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 删除图片(待办事项配图)
export function deleteAffairImage(id) {
  return request({
    url: serviceName + '/affair/image/delete?id=' + id,
    method: 'post',
    data: { id }
  })
}

// 查询留言列表
export function getMessages(data) {
  return request({
    url: serviceName + '/message/list?' + qs.stringify(data),
    method: 'get',
  })
}

// 发表留言
export function createMessage(data) {
  return request({
    url: serviceName + '/message/add',
    method: 'post',
    data
  })
}

// 删除留言
export function deleteMessage(id) {
  return request({
    url: serviceName + '/message/delete?id=' + id,
    method: 'post',
    data: { id }
  })
}

// ========== 以下保留原有的 contents 接口（如果还有用到的话）==========

// 获取内容列表
export function getContents(data) {
  return request({
    url: serviceName + '/contents',
    method: 'get',
    data
  })
}

// 获取单条内容
export function getContentById(id) {
  return request({
    url: serviceName + `/contents/${id}`,
    method: 'get'
  })
}

// 创建内容
export function createContent(data) {
  return request({
    url: serviceName + '/contents',
    method: 'post',
    data
  })
}

// 更新内容
export function updateContent(id, data) {
  return request({
    url: serviceName + `/contents/${id}`,
    method: 'put',
    data
  })
}

// 删除内容
export function deleteContent(id) {
  return request({
    url: serviceName + `/contents/${id}`,
    method: 'delete'
  })
}

// 批量删除
export function batchDelete(ids) {
  return request({
    url: serviceName + '/contents/batch-delete',
    method: 'post',
    data: { ids }
  })
}

// 导出事项 Excel
export function exportContents(data) {
  return request({
    url: serviceName + '/contents/export',
    method: 'get',
    data,
    responseType: 'blob'
  })
}

// 导出导入模板
export function exportTemplate() {
  return request({
    url: serviceName + '/contents/export-template',
    method: 'get',
    responseType: 'blob'
  })
}

// 导入事项
export function importContents(formData) {
  return request({
    url: serviceName + '/contents/import',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 30000
  })
}

// 获取用户列表
export function getUsers(data) {
  return request({
    url: serviceName + '/users',
    method: 'get',
    data
  })
}

// 获取简洁用户列表（用于@提及）
export function getSimpleUsers(data) {
  return request({
    url: serviceName + '/users/simple',
    method: 'get',
    data
  })
}

// 查询所有用户（用于@提及）
export function queryAllUser(keyword) {
  return request({
    url: serviceName + '/user/queryAllUser?keyword=' + (keyword || ''),
    method: 'get',
  })
}

// 查询所有部门（用于#提及）
export function queryAllDepartment() {
  return request({
    url: '/work/dim/all_dept_center',
    method: 'post',
  })
}